<template>
  <form class="sign-in-confirm-phone" @submit.prevent="handlerSubmit">
    <SignBanner result="auth" />
    <ModalComponentBody>
      <SignTitle>
        {{ messages.entry }}
      </SignTitle>
      <SignText>
        {{ messages?.authorizationText }}
      </SignText>
      <p class="sign-in-confirm-phone__text">
        {{ messages.weSentSmsOnNumber }}
      </p>
      <div class="confirm-phone">
        <p class="confirm-phone-number">{{ getPhoneNumber }}</p>
        <button type="button" class="confirm-phone-return" @click="handlerMistake">
          <svg class="confirm-phone-return__icon">
            <use xlink:href="#svg-edit"></use>
          </svg>
          {{ messages.wrongNumber }}
        </button>
      </div>

      <DefInput
        ref="inputCodeComponent"
        v-model="inputValue"
        name="code"
        :placeholder="messages.codeFromSms"
        :is-show-error="Boolean(errorConfirmPhone)"
        inputmode="numeric"
        autocomplete="one-time-code"
        pattern="\d{6}"
        :error-text="errorConfirmPhone"
        autofocus
      />
      <!-- sign in -->
      <DefButtonPrimary type="submit" :disabled="!isValid">
        {{ messages.btnEnter }}
      </DefButtonPrimary>

      <!--      <div class="sign-in-confirm-phone__text">{{ messages.didntGetCode }}</div>-->
      <div v-if="timer > 0" class="confirm-phone-text">
        {{ messages.sendAgainAfter }}
        <span class="confirm-phone-text__counter">{{ timer }} {{ messages.sec }}</span>
      </div>
      <!-- resend message -->
      <button v-else class="resend-message" type="button" @click="handlerResend">
        {{ messages.sendAgain }}
      </button>
    </ModalComponentBody>
  </form>
</template>

<script>
import useModal from '@use/useModal/useModal';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import SignBanner from '@components/Cabinet/Entry/SignBanner.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import SignTitle from '@components/Cabinet/Entry/SignTitle.vue';
import SignText from '@components/Cabinet/Entry/SignText.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { usePersonalStore } from '@/storePinia/stores/personal';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import Recaptcha3 from '../../../../utils/Recaptcha3';
import Analytics from '@/utils/Analytics/Analytics';
import { useBasketStore } from '@/storePinia/stores/basket';

export default {
  name: 'SignInConfirmPhone',
  components: {
    DefInput,
    SignText,
    SignTitle,
    ModalComponentBody,
    SignBanner,
    DefButtonPrimary,
  },
  props: ['result'],
  data() {
    return {
      timer: 90,
      timeOut: null,
      modal: useModal(),
      isValid: false,
      inputValue: '',
      resultsStore: useResultsStore(),
      personalStore: usePersonalStore(),
      basketStore: useBasketStore(),
    };
  },
  computed: {
    errorConfirmPhone() {
      return this.personalStore.errors?.confirmPhone;
    },
    messages() {
      return this.resultsStore.messages.entry;
    },
    getPhoneNumber() {
      return this.result?.formData?.get('phone_number');
    },
  },
  watch: {
    inputValue(val) {
      this.isValid = /^\d{6}$/.test(val);
    },
  },
  mounted() {
    this.counter();

    if ('OTPCredential' in window) {
      const ac = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal,
        })
        .then((otp) => {
          if (otp && otp.code) {
            this.inputValue = otp.code;
            this.isValid = true;
          }
        })
        .catch(console.error);
    }
  },
  beforeUnmount() {
    clearTimeout(this.timeOut);
  },
  methods: {
    handlerSubmit({ target }) {
      const formData = new FormData(target);
      const authType = this.result.formData.get('authType');

      formData.set('phone', this.getPhoneNumber);
      formData.set('authType', authType);

      this.personalStore.confirmPhone(formData, async (data) => {
        await this.basketStore.getData();

        Analytics.signIn(data);
        Analytics.updatedBasket();

        // поставив затримку про всяк випадок щоб аналітика надіслалась.
        setTimeout(() => window.location.reload(), 1000);
      });
    },
    counter() {
      if (this.timer > 0) {
        this.timer -= 1;
        this.timeOut = setTimeout(this.counter, 1000);
      }
    },
    async handlerResend() {
      const { formData } = this.result;
      const token = await Recaptcha3.getSubmitToken();
      formData.append('g-recaptcha-response', token);

      const response = await this.personalStore.signInByPhone(formData);
      if (response) {
        this.timer = 90;
        this.counter();
      }
    },
    handlerMistake() {
      this.modal.show(SignIn, {}, { width: '900px', backgroundClose: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-in-confirm-phone {
  @include point-md {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  &__text {
    font-weight: 500;
    margin-bottom: 8px;

    font-size: 16px;
    line-height: 125%;
  }
  :deep(.def-input) {
    width: 100%;
  }
  :deep(.def-button-primary) {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 24px;
  }
}
.confirm-phone {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.confirm-phone-phone {
  font-size: 14px;
  font-weight: 700;
  line-height: 125%;
  @include point-lg {
    font-size: 16px;
  }
}
.confirm-phone-return {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--color-golden-browm);
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    fill: currentColor;
  }
}
.resend-message {
  display: block;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  text-align: center;
  color: var(--color-golden-browm);
}
.confirm-phone-text {
  color: var(--color-dark-grey);
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  text-align: center;
  &__counter {
    color: var(--color-main);
  }
}
</style>
